import { render, staticRenderFns } from "./EditFlourTypeModal.vue?vue&type=template&id=64161d35&"
import script from "./EditFlourTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditFlourTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports